import React from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/about.css';
import Bubble from '../components/Bubble';

const About = () => {
  const { t } = useTranslation();

  return (
    <div className="about-page">
      <section className="about-hero">
        <h1 className="about-title">{t('about.page.title')}</h1>
      </section>

      <div className="bubble-container">
        {/* Primera fila: Burbujas 1 y 2 */}
        <div className="bubble-row">
          {/* Burbuja 1: Acerca de eDOP */}
          <Bubble 
            className="bubble-1"
            title={t('bubbles.about.edop.title')}
            content={t('bubbles.about.edop.content')}
            color="blue"
            position="center" 
            size="medium"
          />
          
          {/* Burbuja 2: Nuestra Misión */}
          <Bubble 
            className="bubble-2"
            title={t('bubbles.about.mission.title')}
            content={t('bubbles.about.mission.content')}
            color="green"
            position="center"
            size="medium"
          />
        </div>
        
        {/* Segunda fila: Burbujas 3 y 4 */}
        <div className="bubble-row">
          {/* Burbuja 3: Transparencia */}
          <Bubble 
            className="bubble-3"
            title={t('bubbles.about.transparency.title')}
            content={t('bubbles.about.transparency.content')}
            color="orange"
            position="center"
            size="medium"
          />
          
          {/* Burbuja 4: Innovación */}
          <Bubble 
            className="bubble-4"
            title={t('bubbles.about.innovation.title')}
            content={t('bubbles.about.innovation.content')}
            color="purple"
            position="center"
            size="medium"
          />
        </div>
        
        {/* Tercera fila: Burbujas 5 y 6 */}
        <div className="bubble-row">
          {/* Burbuja 5: Comunidad */}
          <Bubble 
            className="bubble-5"
            title={t('bubbles.about.community.title')}
            content={t('bubbles.about.community.content')}
            color="blue"
            position="center"
            size="medium"
          />
          
          {/* Burbuja 6: Nuestro Equipo */}
          <Bubble 
            className="bubble-6"
            title={t('bubbles.about.team.title')}
            content={t('bubbles.about.team.content')}
            color="green"
            position="center"
            size="medium"
          />
        </div>
        
        {/* Cuarta fila: Burbujas 7 y 8 */}
        <div className="bubble-row">
          {/* Burbuja 7: Nuestra Tecnología */}
          <Bubble 
            className="bubble-7"
            title={t('bubbles.about.technology.title')}
            content={t('bubbles.about.technology.content')}
            color="orange"
            position="center"
            size="medium"
          />
          
          {/* Burbuja 8: Velocidad */}
          <Bubble 
            className="bubble-8"
            title={t('bubbles.about.speed.title')}
            content={t('bubbles.about.speed.content')}
            color="purple"
            position="center"
            size="medium"
          />
        </div>
        
        {/* Quinta fila: Burbujas 9 y 10 */}
        <div className="bubble-row">
          {/* Burbuja 9: Bajo Costo */}
          <Bubble 
            className="bubble-9"
            title={t('bubbles.about.lowcost.title')}
            content={t('bubbles.about.lowcost.content')}
            color="blue"
            position="center" 
            size="medium"
          />
          
          {/* Burbuja 10: Seguridad y Contacto */}
          <Bubble 
            className="bubble-10"
            title={t('bubbles.about.security.title')}
            content={t('bubbles.about.security.content')}
            color="green"
            position="center"
            size="medium"
          />
        </div>
      </div>
    </div>
  );
};

export default About;
